import {
  ContentPreviewer,
  Flex,
  RadioButtonCheckedIcon,
  RadioButtonUncheckedIcon,
  styled,
  Text,
} from '@shared/components';

const DetailsWrapper = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.rounded(2),
  backgroundColor: theme.palette.grey[100],
}));

const ChoicesListItemWrapper = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(4),
  gap: theme.spacing(3),
  justifyContent: 'center',
  alignItems: 'flex-start',
}));

export interface PreviewQuestionContentProps {
  details: string;
  choices: Array<{
    label: string;
    order: number;
    isCorrect: boolean;
  }>;
}

export default function PreviewQuestionContent(props: Readonly<PreviewQuestionContentProps>) {
  const { details, choices } = props;

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(4),
        width: '100%',
        maxWidth: '800px',
        flexShrink: 1,
        flexDirection: 'column',
      })}
    >
      <DetailsWrapper>
        <ContentPreviewer content={details} />
      </DetailsWrapper>
      <Flex
        sx={{
          flexDirection: 'column',
        }}
      >
        {choices.map(({ label, isCorrect, order }, index) => (
          <ChoicesListItemWrapper key={index}>
            {isCorrect ? (
              <RadioButtonCheckedIcon
                sx={(theme) => ({
                  color: theme.palette.primary.main,
                  cursor: 'not-allowed',
                })}
              />
            ) : (
              <RadioButtonUncheckedIcon
                sx={(theme) => ({
                  color: theme.palette.grey[400],
                  cursor: 'not-allowed',
                })}
              />
            )}
            <Text sx={{ flexShrink: 0 }}>{order}.</Text>
            <ContentPreviewer content={label} />
          </ChoicesListItemWrapper>
        ))}
      </Flex>
    </Flex>
  );
}
